import { Component } from '@angular/core';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';

import { FleetHeaderComponent } from './layout/fleetheader.component';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';

export interface Tile {
  color: string;
  cols: number;
  rows: number;
  text: string;
}

@Component({
    selector: 'div.dtf-fleetdashboard',
    imports: [SharedTranslateModule, ReactiveFormsModule, MatGridListModule, MatTableModule, MatExpansionModule, MatExpansionPanel, MatToolbarModule, MatNativeDateModule, MatDatepickerModule, MatFormFieldModule, MatIconModule, MatMenuModule,
        MatDialogModule, MatListModule, MatCardModule],
    templateUrl: './fleetdashboard.component.html'
})
export class FleetDashboardComponent {
  panelOpenState = false;
  customCollapsedHeight: string = '50px';
  customExpandedHeight: string = '300px';
  reports: string[] = [
    'Amortization Schedules',
    'Billing ID',
    'Payoff List',
    '90 Days Maturity Report',
    'Lease Tax Report',
    'Title deficiency Report',
    'Billing and Payment History Report',
  ];
  fleets: string[] = [
    'Billing and Payment',
    'Agreement Maintenance',
    'Payoff and Terminations',
  ];  
  insurance: string[] = [
    'F & I Pro 2.0',
    'DTF Literature Order and Dealer Materials',
    'Other Finance Resources',
    'Fair Market Value (FMV) Resources'
  ];
  resources: string[] = [
    'Detroit Assurance 5.0 Video',
    'Detroit Assurance 4.0 - Video de entremient',
  ];
  step = 0;

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  tiles: Tile[] = [
    { text: 'One', cols: 3, rows: 1, color: 'lightblue' },
    { text: 'Two', cols: 1, rows: 2, color: 'lightgreen' },
    { text: 'Three', cols: 1, rows: 1, color: 'lightpink' },
    { text: 'Four', cols: 2, rows: 1, color: '#DDBDF1' },
  ];
}
